import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const StartForm = () => {
  const schema = yup.object().shape({
    clientFirstName: yup.string().required('Please enter a client first name'),
    clientLastName: yup.string().required('Please enter a client last name'),
    clientEmailAddress: yup.string().required('Please enter a client email').email(),
  });

  const { handleSubmit } = useForm({ resolver: yupResolver(schema) });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formData, setFormData] = useState<any>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const submitForm = async (formData: any) => {
    setFormData(formData);
    console.log('setting formData', formData);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (eventData: any) => {
    console.log('handleChange', eventData, formData);
  };

  console.log(handleSubmit, submitForm, handleChange);

  return <></>;
};

export default StartForm;
